/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserMiningProductHashrateResponse } from './user-mining-product-hashrate-response';


export interface UserAccountsSummaryResponse { 
    totalBalanceInBtc: number;
    totalBalanceInUsd: number;
    hashrates: Array<UserMiningProductHashrateResponse>;
    totalActiveWorkers: number;
    totalInactiveWorkers: number;
}

